import styled from 'styled-components';

export const Container = styled.div`
  .monitoring-help-mark {
    font-size: 9px;
    height: 16px;
    width: 16px;
    font-weight: bold;
    text-align: center;
    margin-top: 1px;
    padding-top: 1px;
  }
  @keyframes loadingBars {
    0% {
      top: -2px;
      height: 14px;
    }
    50%,
    100% {
      top: 6px;
      height: 10px;
    }
  }
`;
